import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAsV6rJp9aV896K0w1McERYQa2R7rPN3dM",
  authDomain: "inventariotelefonos-5230c.firebaseapp.com",
  projectId: "inventariotelefonos-5230c",
  storageBucket: "inventariotelefonos-5230c.firebasestorage.app",
  messagingSenderId: "820884038682",
  appId: "1:820884038682:web:244bad287dd9d29052dda3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);